import { Box, Skeleton, Stack, Typography, styled } from "@mui/material";
import { ReactComponent as TrendDownIcon } from "Components/_Shared/Icons/Assets/trend-down.svg";
import { ReactComponent as TrendUpIcon } from "Components/_Shared/Icons/Assets/trend-up.svg";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { formatPercentage } from "Infrastructure/Utils/NumberUtils";

const StyledBox = styled(Box)`
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 12px;
`;

type Props = {
  readonly metricName: string;
  readonly metricValue: number;
  readonly changeInPercent: number;
  readonly icon: React.ReactNode;
  readonly loading?: boolean;
};

export const MetricItem: React.FC<Props> = ({ metricName, metricValue, changeInPercent, icon, loading }) => {
  const { t } = useResource();
  const isNegative = changeInPercent < 0;
  if (loading) {
    return (
      <>
        <Skeleton variant="rounded" height={112} />
        <Skeleton variant="text" sx={{ fontSize: 32 }} />
      </>
    );
  }

  return (
    <StyledBox padding={Spacing.XXL}>
      <Stack spacing={5}>
        {icon}
        <Typography variant="body2" color="secondary" fontWeight={600}>
          {metricName}
        </Typography>
        <Box display="flex" justifyContent="space-between" alignItems="center" whiteSpace="pre">
          <Typography variant="h1" lineHeight={0.8}>
            {metricValue}
          </Typography>
          <Box display="flex">
            <Box display="flex">
              {isNegative ? <TrendDownIcon /> : <TrendUpIcon />}
              <Typography variant="body2" fontWeight={500} color={isNegative ? "error" : "success"} marginLeft={Spacing.S}>
                {formatPercentage(changeInPercent)}
              </Typography>
            </Box>

            <Typography variant="body2" fontWeight={500} color="secondary">
              {" "}
              {t(Resources.Dashboard.ComparedToLastMonth)}
            </Typography>
          </Box>
        </Box>
      </Stack>
    </StyledBox>
  );
};
